import { Mail } from "lucide-react";

import { PageHero } from "@/components/layout/PageHero";
import { pages } from "@/content/pages";
import type { Locale } from "@/i18n/locales";

type ContactViewProps = {
  locale: Locale;
};

export function ContactView({ locale }: ContactViewProps) {
  const copy = pages[locale].contact;

  return (
    <main className="bg-background">
      <PageHero eyebrow={copy.eyebrow} title={copy.title} intro={copy.intro} />
      <div className="mx-auto max-w-4xl px-5 pb-24">
        <div className="grid gap-5 md:grid-cols-2">
          <a
            href={`mailto:${copy.infoEmail}`}
            className="rounded-2xl border border-border bg-white p-7 shadow-sm transition hover:border-primary/40"
          >
            <Mail className="h-8 w-8 text-primary" />
            <h2 className="mt-5 font-heading text-2xl font-bold text-[#1a3a5c]">
              {copy.generalLabel}
            </h2>
            <p className="mt-2 font-semibold text-primary">{copy.infoEmail}</p>
          </a>
          <a
            href={`mailto:${copy.legacyEmail}`}
            className="rounded-2xl border border-border bg-white p-7 shadow-sm transition hover:border-primary/40"
          >
            <Mail className="h-8 w-8 text-primary" />
            <h2 className="mt-5 font-heading text-2xl font-bold text-[#1a3a5c]">
              {copy.legacyLabel}
            </h2>
            <p className="mt-2 font-semibold text-primary">
              {copy.legacyEmail}
            </p>
          </a>
        </div>
      </div>
    </main>
  );
}
